import React, { FC } from 'react';
import Section from '../../../Components/Section/Section';
import Container from '../../../../../Common/Container/Container';
import SectionTitle from '../../../../../Common/SectionTitle/SectionTitle';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import Heading from '../../../Components/Heading/Heading';
import RatesList from '../../../Components/RatesList/RatesList';
import * as classes from './PricingSection.module.scss';
import { ServicePricingSectionProps } from '../../../../../Sections/Services/PricingSection/PricingSection';
import DefaultButton from '../../../Components/DefaultButton/DefaultButton';

const PricingSection: FC<ServicePricingSectionProps> = ({ serviceName, rates, paymentsMethods, paymentsAdditionalDescription }) => {
  const { t } = useTranslation();
  const paymentsInfo = (
    <div className={classes.paymentsMethodsInfoWrapper}>
      <Heading>{t('services.pricingSection.paymentMethodsHeading')}</Heading>
      {!!paymentsMethods && <div className={classes.paymentsMethodsList}>{paymentsMethods.join(', ')}</div>}
      {paymentsAdditionalDescription && (
        <div className={classes.paymentsMethodsAdditionalDescription} dangerouslySetInnerHTML={{ __html: paymentsAdditionalDescription }} />
      )}
    </div>
  );

  return (
    <Section number={'03'} label={t('services.pricingSection.sectionTitle')}>
      <Container className={classes.wrapper}>
        <div className={'row'}>
          <div className='col-xl-4 col-lg-4 col-md-5 col-sm-12'>
            <SectionTitle>
              {serviceName} {t('services.pricingSection.titleText')}
            </SectionTitle>
            <div className={'d-none d-md-block'}>{paymentsInfo}</div>
          </div>
          <div className='col-xl-7 col-lg-7 offset-lg-1 offset-md-1 col-md-6 col-sm-12'>
            <div className={classes.ratesListWrapper}>{!!rates.length && <RatesList items={rates} />}</div>
            <div className={'d-md-none'}>{paymentsInfo}</div>
            {!rates.length && <div className={classes.ratesNotFoundText}>{t('services.pricingSection.ratesNotFoundText')}</div>}
            <div className={'d-flex'}>
              <DefaultButton
                link={{
                  path: t('services.pricingSection.getInTouchButton.url'),
                  title: t('services.pricingSection.getInTouchButton.title'),
                }}
              >
                {t('services.pricingSection.getInTouchButton.label')}
              </DefaultButton>
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default PricingSection;
